export default __webpack_public_path__ + "static/media/Ellipse 23 (2).e36f2651.png";